<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }" ref="form">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <validation-provider rules="required" v-slot="{ errors }" name="First Name">
        <label class="block">
          <div class="text-gray-300">
            First Name / ชื่อ
            <span class="text-red-300">*</span>
          </div>
          <input
            v-model="form.firstName"
            id="first-name"
            name="first-name"
            type="text"
            class="form-input appearance-none focus:outline-none mt-1 block w-full"
          />
        </label>
        <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider rules="required" v-slot="{ errors }" name="Last Name">
        <label class="block mt-2">
          <div class="text-gray-300">
            Last Name / นามสกุล
            <span class="text-red-300">*</span>
          </div>
          <input
            v-model="form.lastName"
            id="last-name"
            name="last-name"
            type="text"
            class="form-input mt-1 block w-full"
          />
        </label>
        <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider rules="required|email" v-slot="{ errors }" name="Email">
        <label class="block mt-2">
          <div class="text-gray-300">
            Email / อีเมล
            <span class="text-red-300">*</span>
          </div>
          <input
            v-model="form.email"
            id="email"
            name="email"
            type="email"
            class="form-input mt-1 block w-full"
          />
        </label>
        <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Phone Number">
        <label class="block mt-2">
          <div class="text-gray-300">
            Phone Number / เบอร์โทร
          </div>
          <input
            v-model="form.phoneNumber"
            id="phone-number"
            name="phone-number"
            type="tel"
            class="form-input mt-1 block w-full"
          />
        </label>
        <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider rules="required" v-slot="{ errors }" name="Account Type">
        <div class="mt-2">
          <div class="text-gray-300">
            Account Type
            <span class="text-red-300">*</span>
          </div>
          <div class="flex flex-wrap mt-2">
            <div class="w-full">
              <label class="inline-flex items-center text-gray-300">
                <input
                  type="radio"
                  class="form-radio"
                  name="accountType"
                  v-model="form.accountType"
                  value="Investor"
                />
                <span class="ml-2">Investor</span>
              </label>
              <validation-provider
                :rules="`${form.accountType == 'Investor' ? 'required' : ''}`"
                v-slot="{ errors }"
                name="Referrer Name"
              >
                <div v-show="form.accountType == 'Investor'" class="my-2">
                  <input
                    v-model="form.referrerName"
                    id="referrer-name"
                    name="referrer-name"
                    type="text"
                    placeholder="Referrer / ผู้แนะนำ"
                    class="form-input appearance-none focus:outline-none mt-1 block w-full"
                  />
                  <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
            <div class="w-full">
              <label class="inline-flex items-center text-gray-300">
                <input
                  type="radio"
                  class="form-radio"
                  name="accountType"
                  v-model="form.accountType"
                  value="Corporate Agent"
                />
                <span class="ml-2">Corporate Agent</span>
              </label>
              <validation-provider
                :rules="`${form.accountType == 'Corporate Agent' ? 'required' : ''}`"
                v-slot="{ errors }"
                name="Corporate Name"
              >
                <div v-show="form.accountType == 'Corporate Agent'" class="mt-2">
                  <input
                    v-model="form.accountName"
                    id="account-name"
                    name="account-name"
                    type="text"
                    placeholder="Corporate Name"
                    class="form-input appearance-none focus:outline-none mt-1 block w-full"
                  />
                  <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
          </div>
          <span class="text-red-300 text-xs italic">{{ errors[0] }}</span>
        </div>
      </validation-provider>

      <div class="flex justify-center">
        <button type="submit" :disabled="invalid" class="mt-6 btn-default uppercase">
          <template v-if="sending">Sending...</template>
          <template v-else>Submit</template>
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'register-form',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      sending: false,
      form: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        accountType: null,
        accountName: null,
        referrerName: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      if (this.sending) {
        return;
      }

      this.sending = true;
      try {
        await this.$store.dispatch('submitForm', this.form);
        this.$swal({
          title: 'Thank you for your registration',
          icon: 'success',
        }).then(() => {
          this.$nextTick(() => {
            this.$refs.form.reset();
          });
          this.resetForm();
        });
      } catch (e) {
        this.$swal('Error!', 'Something went wrong. Please Try Again.', 'error');
      }
      this.sending = false;
    },
    resetForm() {
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.phoneNumber = null;
      this.form.email = null;
      this.form.accountType = null;
      this.form.accountName = null;
      this.form.referrerName = null;
    },
  },
};
</script>
